<template>
  <div id="app">
    <router-view v-if="RouterState" />
  </div>
</template>
<script>
//火山引擎-增长分析 创建script标签，引入外部文件
let scripttext = document.createElement("script");
scripttext.type = "text/javascript";
scripttext.text = `
  	(function(win, export_obj) {
  	    win['TeaAnalyticsObject'] = export_obj;
  	    if (!win[export_obj]) {
  	        function _collect() {
  	            _collect.q.push(arguments);
  	        }
  	        _collect.q = _collect.q || [];
  	        win[export_obj] = _collect;
  	    }
  	    win[export_obj].l = +new Date();
  	})(window, 'collectEvent');
  `;
document.getElementsByTagName("head")[0].appendChild(scripttext);
let script = document.createElement("script");
script.type = "text/javascript";
script.src =
  "https://lf3-data.volccdn.com/obj/data-static/log-sdk/collect/collect-autotrack-rangers.js";
document.getElementsByTagName("head")[0].appendChild(script);

let scriptautotrack = document.createElement("script");
scriptautotrack.type = "text/javascript";
scriptautotrack.text = `
  	window.collectEvent('init', {
  	            app_id:233677,
  	            channel: 'cn',
  	            autotrack: false  //默认关闭，需要热力图及圈选功能可开启
  	        });
  	        window.collectEvent('start');
  `;
document.getElementsByTagName("head")[0].appendChild(scriptautotrack);

import Vue from "vue";
import App from "./App.vue";

export default {
  name: "App",
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      RouterState: true
    };
  },
  methods: {
    reload() {
      this.RouterState = false;
      this.$nextTick(() => {
        this.RouterState = true;
      });
    }
  }
};
</script>

<style>
* {
  padding: 0;
  margin: 0;
}

body {
  margin: 0;
  padding: 0;
}
a {
  text-decoration: none;
}
li {
  list-style: none;
}
#app {
  /* filter: grayscale(100%);将天云网首页转化为灰色  */
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  text-align: center;
  overflow: hidden;
  margin: 0 auto;
  padding: 0;
}
.float-left {
  float: left;
}
.float-right {
  float: right;
}
.pt4 {
  padding-top: 4px;
}
.ml40 {
  margin-left: 40px;
}
.mr20 {
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue